import React from "react";
import { Link } from "react-router-dom";
import {
  profile,
  social,
  education,
  experience,
  projects,
  projectsNote,
  skills,
  languages,
} from "./data";

const stripProtocol = (url) => url.replace(/^https?:\/\//, "").replace(/\/$/, "");

const Resume = () => (
  <div className="container">
    <header className="resume-header">
      <h1>{profile.fullName}</h1>
      <div className="personal-info">
        <p>{profile.phone}</p>
        <p>
          <a href={`mailto:${profile.email}`}>{profile.email}</a>
        </p>
        <p>{profile.location}</p>
        <p>
          <a href={profile.siteUrl} target="_blank" rel="noreferrer">
            {profile.site}
          </a>
        </p>
      </div>
    </header>

    <section>
      <div className="link-row">
        <p>
          <strong>GitHub: </strong>
          <a href={social.github} target="_blank" rel="noreferrer">
            {stripProtocol(social.github)}
          </a>
        </p>
        <p>
          <strong>LinkedIn: </strong>
          <a href={social.linkedin} target="_blank" rel="noreferrer">
            {stripProtocol(social.linkedin)}
          </a>
        </p>
      </div>
    </section>

    <section>
      <h2>Education</h2>
      {education.map((item) => (
        <div className="entry" key={item.school}>
          <div className="entry-head">
            <h3>{item.school}</h3>
            <span className="date">{item.date}</span>
          </div>
          <p>{item.degree}</p>
          <p className="muted">{item.location}</p>
        </div>
      ))}
    </section>

    <section>
      <h2>Experience</h2>
      {experience.map((item) => (
        <div className="entry" key={item.company}>
          <div className="entry-head">
            <h3>
              {item.role} —{" "}
              {item.href ? (
                <a href={item.href} target="_blank" rel="noreferrer">
                  {item.company}
                </a>
              ) : (
                item.company
              )}
            </h3>
            <span className="date">{item.date}</span>
          </div>
          <p className="muted">{item.location}</p>
          <ul>
            {item.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        </div>
      ))}
    </section>

    <section>
      <h2>Projects</h2>
      <p className="muted section-note">{projectsNote}</p>
      {projects.map((item) => (
        <div className="entry" key={item.title}>
          <div className="entry-head">
            <h3>
              <a href={item.href} target="_blank" rel="noreferrer">
                {item.title}
              </a>
            </h3>
            <span className="date">{item.date}</span>
          </div>
          <p>{item.body}</p>
        </div>
      ))}
    </section>

    <section>
      <h2>Skills</h2>
      {skills.map((item) => (
        <div className="kv" key={item.label}>
          <div className="kv-label">{item.label}</div>
          <div className="kv-value">{item.value}</div>
        </div>
      ))}
    </section>

    <section>
      <h2>Languages</h2>
      {languages.map((item) => (
        <p key={item.label}>
          <strong>{item.label}</strong> — {item.value}
        </p>
      ))}
    </section>

    <footer>
      <span>
        © {new Date().getFullYear()} {profile.name}
      </span>
      <Link className="link" to="/">
        Home
      </Link>
    </footer>
  </div>
);

export default Resume;
